import { render, staticRenderFns } from "./Iconstyle.vue?vue&type=template&id=2240f112&"
import script from "./Iconstyle.vue?vue&type=script&lang=js&"
export * from "./Iconstyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports